import type { GetLocationsInput, LocationCreateDto, LocationDto, LocationUpdateDto } from './models';
import { RestService } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  apiName = 'Inventory';

  create = (input: LocationCreateDto) =>
    this.restService.request<any, LocationDto>({
      method: 'POST',
      url: `/api/inventory/locations`,
      body: input,
    },
    { apiName: this.apiName });

  delete = (id: string) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/inventory/locations/${id}`,
    },
    { apiName: this.apiName });

  get = (id: string) =>
    this.restService.request<any, LocationDto>({
      method: 'GET',
      url: `/api/inventory/locations/${id}`,
    },
    { apiName: this.apiName });

  getList = (input: GetLocationsInput) =>
    this.restService.request<any, PagedResultDto<LocationDto>>({
      method: 'GET',
      url: `/api/inventory/locations`,
      params: { filterText: input.filterText, name: input.name, description: input.description, code: input.code, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  update = (id: string, input: LocationUpdateDto) =>
    this.restService.request<any, LocationDto>({
      method: 'PUT',
      url: `/api/inventory/locations/${id}`,
      body: input,
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
